module.exports = __webpack_public_path__ + "img/logo_gms.fbf114fc.png";